import React, { useContext, FC } from 'react';
import { CgGoogle, CgFacebook } from 'react-icons/cg';
import Card from '../Card/Card';
import styles from './Authentication.module.scss';
import { signInWithGoogle, signInWithFacebook } from '../../Services/firebase';
import Button from '../Button/Button';
import { types } from '../../Context/Reducers/Reducer';
import { Context } from '../../Context/Context';

const Authentication: FC = () => {
  const { dispatch } = useContext(Context);

  const toggleModal = () => {
    dispatch({
      type: types.SHOW_MODAL,
    });
  };

  const handleGoogleSignIn = async () => {
    await signInWithGoogle();
    toggleModal();
  };

  const handleFacebookSignIn = async () => {
    await signInWithFacebook();
    toggleModal();
  };

  return (
    <div className={styles.authentication}>
      <Card>
        <div className={styles.cardTitle}>Log in / Sign up</div>
        <div className={styles.cardSubTitle}>Log in / Sign up using your</div>
        <div className={styles.socialLogin}>
          <Button width="20vw" onClick={handleGoogleSignIn}>
            <div className={styles.buttonContent}>
              <div className={styles.buttonIcon}>
                <CgGoogle />
              </div>
              {' '}
              Google Account
            </div>
          </Button>
          <Button onClick={handleFacebookSignIn}>
            <div className={styles.buttonContent}>
              <div className={styles.buttonIcon}>
                <CgFacebook />
              </div>
              {' '}
              Facebook Account
            </div>
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Authentication;
